import { INVOICE_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { useAdditionalPropertyValues } from './useAdditionalPropertyValues';
import { isReadOnlyInvoiceProperty } from 'customer-data-objects/invoice/isReadOnlyInvoiceProperty';
export const useIsReadOnlyInvoiceProperty = (objectTypeId, propertyDefinition) => {
  const {
    data,
    loading
  } = useAdditionalPropertyValues({
    // Controlling property - Whether Invoice is billable or not
    // https://tools.hubteam.com/lighthouse/objects/INVOICE/properties/hs_invoice_billable/details/0
    hs_invoice_billable: 'hs_invoice_billable'
  }, {
    skip: objectTypeId !== INVOICE_TYPE_ID || !propertyDefinition.hubspotDefined
  });
  if (loading) {
    return true;
  }
  return isReadOnlyInvoiceProperty({
    objectTypeId,
    property: propertyDefinition,
    isBillableInvoice: data === null || data === void 0 ? void 0 : data.hs_invoice_billable
  });
};